import axiosInstance from "../../services/axios";

export const RegionService = {
  getAll: async ()=> {
    try {
      const response = await axiosInstance.get(`/regions`);
      return response.data.data;
    } catch (error: unknown) {
      console.error("Error fetching regions:", error);
      throw new Error(
        (error as Error).message || "An unknown error occurred while fetching regions."
      );
    }
  },
};
